export default __webpack_public_path__ + "static/media/bolt.117bf8fd.png";